import { SupervisorBandwidthEnum } from '@src/lookup';
import React from 'react';
import { MoChip } from '../MoChip';
import { MoStatusLabel, MoStatusLabelColor } from '../MoStatusLabel';

type DisplayStyle = 'dot' | 'chip';

const labels: Partial<Record<SupervisorBandwidthEnum, string>> = {
  [SupervisorBandwidthEnum.READY]: 'Open',
  [SupervisorBandwidthEnum.NONE]: 'Closed',
};

const bandwidthToStatusColor: Record<SupervisorBandwidthEnum, MoStatusLabelColor> = {
  [SupervisorBandwidthEnum.READY]: 'success',
  [SupervisorBandwidthEnum.LIMITED]: 'warning',
  [SupervisorBandwidthEnum.NONE]: 'error',
};

const chipStyles: Partial<Record<SupervisorBandwidthEnum, { bgcolor: string; color: string }>> = {
  [SupervisorBandwidthEnum.READY]: { bgcolor: 'spruce.dark', color: '#fff' },
  [SupervisorBandwidthEnum.NONE]: { bgcolor: 'grey.700', color: '#fff' },
};

export const MoBandwidthStatus = ({
  supervisorBandwidthId,
  hideLabel,
  displayStyle = 'dot',
}: {
  supervisorBandwidthId: SupervisorBandwidthEnum;
  hideLabel?: boolean;
  displayStyle?: DisplayStyle;
}) => {
  const label = labels[supervisorBandwidthId];
  const statusColor = bandwidthToStatusColor[supervisorBandwidthId];

  if (!label) {
    return <>-</>;
  }

  if (displayStyle === 'chip') {
    const customStyle = chipStyles[supervisorBandwidthId];
    if (customStyle) {
      return (
        <MoChip
          label={hideLabel ? '' : label}
          size="sm"
          sx={{ bgcolor: customStyle.bgcolor, color: customStyle.color }}
        />
      );
    }
  }

  return <MoStatusLabel color={statusColor} label={hideLabel ? '' : label} />;
};
